import dynamic from 'next/dynamic';
import Custom404 from '@/components/pages/404';
import { SegmentationListingPageProps } from '@/components/pages/segmentationListings/segmentationListingPageProps';
import { searchDirectoryTypeFromSearchResults } from '@/helpers/searchDirectoryTypeFromSearchResults';
import { SEARCH_DIRECTORY_TEMPLATE_TYPE } from '@/constants';
import { SearchDirectoryLayout } from './SearchDirectoryLayout';

const CaregiverSearchDirectory = dynamic(() => {
  return import('@/components/page/CaregiverSearchDirectory');
});

const JobSearchDirectory = dynamic(() => {
  return import('@/components/page/JobSearchDirectory');
});

const HybridSearchDirectory = dynamic(() => {
  return import('@/components/page/HybridSearchDirectory');
});

const SMBSearchDirectory = dynamic(() => {
  return import('@/components/page/SMBSearchDirectory');
});

export const SearchDirectoryController = (props: SegmentationListingPageProps) => {
  const { pageData, enrollmentURL, deviceChar, testName } = props;
  const { seoSegmentationSearchResults: searchResults } = pageData;

  const renderDirectoryContent = () => {
    const searchDirectoryType = searchDirectoryTypeFromSearchResults(searchResults);
    switch (searchDirectoryType) {
      case SEARCH_DIRECTORY_TEMPLATE_TYPE.CAREGIVER:
        return <CaregiverSearchDirectory {...props} />;
      case SEARCH_DIRECTORY_TEMPLATE_TYPE.SMB:
        return <SMBSearchDirectory {...props} />;
      case SEARCH_DIRECTORY_TEMPLATE_TYPE.HYBRID:
        return <HybridSearchDirectory {...props} />;
      case SEARCH_DIRECTORY_TEMPLATE_TYPE.JOB:
        return <JobSearchDirectory {...props} />;
      default:
        return <Custom404 showGlobalNav={false} />;
    }
  };

  return (
    <SearchDirectoryLayout
      pageData={pageData}
      testName={testName}
      enrollmentURL={enrollmentURL}
      deviceChar={deviceChar}>
      {renderDirectoryContent()}
    </SearchDirectoryLayout>
  );
};

export default SearchDirectoryController;
